import { CKSkeleton } from 'clearkit';

const loadingItems = Array.from(Array(20));

const LoadingListItem = () => (
  <CKSkeleton
    className="rounded @item/list:h-[6.375rem] h-[10.90625rem]"
    isLoading
  />
);

export const LoadingList = () => (
  <>
    {loadingItems.map((_, index) => (
      <LoadingListItem key={index} />
    ))}
  </>
);
